import './src/assets/global.css'

export const onServiceWorkerUpdateReady = () => {
    // window.location.reload(true)
}
